export interface MamaApprovedReview {
  reviewerName: string;
  rating: number;
  comment: string;
  date: string;
}

export interface MamaApprovedBusiness {
  id: string;
  name: string;
  category: string;
  location: string;
  logo: string;
  description: string;
  averageRating: number;
  reviewCount: number;
  reviews: MamaApprovedReview[];
  memberDiscount: string;
  tags: string[];
  isFeaturedPartner?: boolean;
}

export const mamaApprovedBusinesses: MamaApprovedBusiness[] = [
  {
    id: 'ma-1',
    name: 'Moments by Melissa Photography',
    category: 'Photographers',
    location: 'Sugar Hill, GA',
    isFeaturedPartner: true,
    logo: 'https://public.readdy.ai/ai/img_res/b47f003c2a819fc171ee90d3f0d33b79.jpg',
    description: 'Natural light family photographer serving Gwinnett County for over 8 years. Specializing in newborns, milestones, and family portraits with a warm, candid style that captures real moments.',
    averageRating: 5.0,
    reviewCount: 47,
    reviews: [
      { reviewerName: 'Brittany J.', rating: 5, comment: 'Melissa is absolutely amazing! She captured our family perfectly and made the whole session fun and relaxed. The photos are treasures we will keep forever.', date: '2024-06-30' },
      { reviewerName: 'Danielle P.', rating: 5, comment: 'Best newborn photographer in Gwinnett! So patient and gentle with our baby. The photos are absolutely stunning.', date: '2024-06-18' },
      { reviewerName: 'Heather G.', rating: 5, comment: 'We\'ve used Melissa for years and she never disappoints. Highly recommend for family photos!', date: '2024-05-25' }
    ],
    memberDiscount: '$50 off your session fee',
    tags: ['Family Portraits', 'Newborns', 'Milestones']
  },
  {
    id: 'ma-2',
    name: 'Sweet Dreams Baby Sleep Consulting',
    category: 'Mom Businesses',
    location: 'Sugar Hill, GA',
    isFeaturedPartner: true,
    logo: 'https://readdy.ai/api/search-image?query=baby%20sleep%20consulting%20brand%20logo%20with%20moon%20and%20stars%20soft%20pastel%20colors%20peaceful%20dreamy%20design%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo2&orientation=squarish',
    description: 'Certified sleep consultant helping exhausted parents get their babies sleeping through the night. Personalized sleep plans, phone support, and follow-up included. Founded by a local Sugar Hill mom of three.',
    averageRating: 5.0,
    reviewCount: 52,
    reviews: [
      { reviewerName: 'Elizabeth W.', rating: 5, comment: 'Life changing! Our baby went from waking every 2 hours to sleeping 11 hours straight. Worth every single penny!', date: '2024-06-22' },
      { reviewerName: 'Sarah J.', rating: 5, comment: 'So knowledgeable and supportive. She answered all my questions and the plan actually worked!', date: '2024-06-10' },
      { reviewerName: 'Amanda K.', rating: 5, comment: 'Best investment we made as new parents. Our whole family is sleeping better now.', date: '2024-05-30' }
    ],
    memberDiscount: '$75 off sleep consultation package',
    tags: ['Sleep Training', 'Newborns', 'Toddlers']
  },
  {
    id: 'ma-3',
    name: 'Stroller Strides Gwinnett',
    category: 'Fitness',
    location: 'Lawrenceville, GA',
    logo: 'https://readdy.ai/api/search-image?query=fitness%20brand%20logo%20with%20stroller%20and%20running%20figure%20energetic%20pink%20and%20green%20colors%20active%20lifestyle%20branding%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo3&orientation=squarish',
    description: 'Outdoor fitness classes designed for moms with strollers. Total body workout while your little one enjoys the ride. Build strength, confidence, and community — all fitness levels welcome.',
    averageRating: 4.9,
    reviewCount: 45,
    reviews: [
      { reviewerName: 'Jamie L.', rating: 5, comment: 'Love this class! Great workout and I\'ve made so many mom friends. My baby loves it too!', date: '2024-06-26' },
      { reviewerName: 'Erin B.', rating: 5, comment: 'Perfect for new moms! The instructor modifies exercises for all fitness levels.', date: '2024-06-14' },
      { reviewerName: 'Morgan T.', rating: 5, comment: 'Best part of my week! Getting fit and socializing at the same time.', date: '2024-06-02' }
    ],
    memberDiscount: 'First class FREE for members',
    tags: ['Outdoor Fitness', 'Stroller-Friendly', 'Community']
  },
  {
    id: 'ma-4',
    name: 'Balloon Bliss Decor',
    category: 'Party Vendors',
    location: 'Buford, GA',
    isFeaturedPartner: true,
    logo: 'https://readdy.ai/api/search-image?query=balloon%20decor%20company%20logo%20colorful%20balloons%20and%20celebration%20design%20festive%20pink%20gold%20and%20white%20branding%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo4&orientation=squarish',
    description: 'Custom balloon installations and party decor for every occasion. Balloon arches, columns, centerpieces, and full setups. Delivery and installation included. Perfect for birthdays, baby showers, and community events.',
    averageRating: 5.0,
    reviewCount: 48,
    reviews: [
      { reviewerName: 'Gabriella S.', rating: 5, comment: 'Absolutely stunning balloon arch for my daughter\'s birthday! Everyone was amazed and kept asking who did the decor!', date: '2024-06-20' },
      { reviewerName: 'Destiny M.', rating: 5, comment: 'Professional, creative, and on time. The balloon decor made the party absolutely perfect!', date: '2024-06-08' },
      { reviewerName: 'Savannah L.', rating: 5, comment: 'Worth every penny! The setup was gorgeous and lasted the entire party.', date: '2024-05-25' }
    ],
    memberDiscount: '15% off all packages',
    tags: ['Balloon Arches', 'Party Decor', 'Baby Showers']
  },
  {
    id: 'ma-5',
    name: 'Blush & Blow Salon',
    category: 'Hair & Beauty',
    location: 'Suwanee, GA',
    logo: 'https://readdy.ai/api/search-image?query=hair%20salon%20logo%20elegant%20script%20font%20with%20floral%20accent%20soft%20rose%20gold%20and%20blush%20pink%20tones%20luxury%20beauty%20branding%20on%20white%20background&width=200&height=200&seq=malogo5&orientation=squarish',
    description: 'Full-service salon specializing in cuts, color, and styling. Complimentary beverages and a relaxing atmosphere. Mom-friendly with flexible scheduling and online booking available.',
    averageRating: 4.8,
    reviewCount: 56,
    reviews: [
      { reviewerName: 'Victoria R.', rating: 5, comment: 'My stylist is amazing! She always knows exactly what I want. Love this salon so much!', date: '2024-06-24' },
      { reviewerName: 'Chloe W.', rating: 5, comment: 'Great atmosphere and talented stylists. They work with my busy mom schedule.', date: '2024-06-11' },
      { reviewerName: 'Madison L.', rating: 4, comment: 'Beautiful salon and great service. Prices are a bit high but absolutely worth it for the quality.', date: '2024-05-29' }
    ],
    memberDiscount: '15% off all services',
    tags: ['Hair Color', 'Styling', 'Blowouts']
  },
  {
    id: 'ma-6',
    name: 'Little Sprouts Boutique',
    category: 'Mom Businesses',
    location: 'Sugar Hill, GA',
    logo: 'https://readdy.ai/api/search-image?query=children%20clothing%20boutique%20logo%20with%20small%20sprout%20plant%20and%20leaf%20design%20soft%20green%20and%20pink%20colors%20cute%20minimalist%20branding%20on%20white%20background&width=200&height=200&seq=malogo6&orientation=squarish',
    description: 'Curated children\'s clothing and accessories boutique featuring unique brands you won\'t find in big box stores. Owned by a local Sugar Hill mom with an eye for style and quality.',
    averageRating: 4.9,
    reviewCount: 27,
    reviews: [
      { reviewerName: 'Courtney D.', rating: 5, comment: 'Love this shop! The owner has great taste and the quality is excellent. My absolute go-to for gifts.', date: '2024-06-12' },
      { reviewerName: 'Allison R.', rating: 5, comment: 'Such cute clothes and the owner is so sweet! Support local moms!', date: '2024-05-28' }
    ],
    memberDiscount: '10% off all purchases',
    tags: ['Kids Fashion', 'Gifts', 'Local Boutique']
  },
  {
    id: 'ma-7',
    name: 'Bright Minds Tutoring',
    category: 'Tutors',
    location: 'Gwinnett County, GA',
    logo: 'https://readdy.ai/api/search-image?query=tutoring%20center%20logo%20with%20lightbulb%20and%20book%20design%20bright%20yellow%20and%20teal%20colors%20educational%20branding%20clean%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo7&orientation=squarish',
    description: 'One-on-one and small group tutoring for K-12 students. All subjects including math, reading, science, and test prep. Certified teachers with proven results and a passion for helping kids succeed.',
    averageRating: 4.9,
    reviewCount: 31,
    reviews: [
      { reviewerName: 'Diana K.', rating: 5, comment: 'My son\'s grades improved dramatically! The tutor is patient and really knows how to explain concepts clearly.', date: '2024-06-17' },
      { reviewerName: 'Vanessa P.', rating: 5, comment: 'Excellent tutoring service. My daughter went from struggling to confident in math.', date: '2024-06-03' }
    ],
    memberDiscount: 'First session FREE',
    tags: ['K-12', 'Math', 'Test Prep']
  },
  {
    id: 'ma-8',
    name: 'Party Princess Characters',
    category: 'Party Vendors',
    location: 'Duluth, GA',
    isFeaturedPartner: true,
    logo: 'https://readdy.ai/api/search-image?query=princess%20character%20entertainment%20company%20logo%20with%20crown%20and%20sparkles%20magical%20pink%20and%20gold%20colors%20fairytale%20branding%20on%20white%20background&width=200&height=200&seq=malogo8&orientation=squarish',
    description: 'Professional character performers for birthday parties and events. Princesses, superheroes, and more. Interactive entertainment including games, songs, and photo opportunities that kids will never forget.',
    averageRating: 5.0,
    reviewCount: 52,
    reviews: [
      { reviewerName: 'Mackenzie T.', rating: 5, comment: 'The princess was AMAZING! My daughter thought she was real. Absolute best party ever!', date: '2024-06-19' },
      { reviewerName: 'Bailey W.', rating: 5, comment: 'Professional, punctual, and the kids were completely mesmerized. Worth every penny!', date: '2024-06-07' },
      { reviewerName: 'Kennedy M.', rating: 5, comment: 'Incredible entertainment! The character stayed in role the entire time.', date: '2024-05-24' }
    ],
    memberDiscount: '$25 off character bookings',
    tags: ['Princesses', 'Superheroes', 'Birthday Parties']
  },
  {
    id: 'ma-9',
    name: 'Little Maestros Music School',
    category: 'Kids Activities',
    location: 'Lawrenceville, GA',
    logo: 'https://readdy.ai/api/search-image?query=music%20school%20logo%20with%20musical%20notes%20and%20treble%20clef%20colorful%20playful%20design%20for%20children%20warm%20orange%20and%20teal%20tones%20on%20white%20background&width=200&height=200&seq=malogo9&orientation=squarish',
    description: 'Music lessons for children ages 3 and up. Piano, guitar, violin, and voice instruction. Group classes and private lessons available. Recitals twice a year to celebrate student progress.',
    averageRating: 4.9,
    reviewCount: 26,
    reviews: [
      { reviewerName: 'Rebecca L.', rating: 5, comment: 'Wonderful music program! My son has learned so much and actually practices without being asked.', date: '2024-06-20' },
      { reviewerName: 'Maria G.', rating: 5, comment: 'The teachers are talented musicians and great with kids. Can\'t recommend enough!', date: '2024-06-08' }
    ],
    memberDiscount: 'First month 25% off',
    tags: ['Piano', 'Guitar', 'Voice Lessons']
  },
  {
    id: 'ma-10',
    name: 'Gwinnett Family Dentistry',
    category: 'Doctors',
    location: 'Gwinnett County, GA',
    logo: 'https://readdy.ai/api/search-image?query=family%20dentistry%20logo%20with%20tooth%20and%20smile%20design%20clean%20teal%20and%20white%20colors%20professional%20medical%20branding%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo10&orientation=squarish',
    description: 'Family-friendly dental practice serving patients of all ages. Preventive care, cosmetic dentistry, and orthodontics. Kid-friendly environment with TVs in every room to keep little ones calm.',
    averageRating: 4.8,
    reviewCount: 54,
    reviews: [
      { reviewerName: 'Alexis D.', rating: 5, comment: 'Great with kids! My son was nervous but the staff made him feel so comfortable.', date: '2024-06-18' },
      { reviewerName: 'Haley N.', rating: 5, comment: 'Whole family goes here. Professional, gentle, and the office is always spotlessly clean.', date: '2024-06-06' }
    ],
    memberDiscount: 'Free teeth whitening with new patient exam',
    tags: ['Pediatric Dentistry', 'Cosmetic', 'Orthodontics']
  },
  {
    id: 'ma-11',
    name: 'Barre & Baby Fitness',
    category: 'Fitness',
    location: 'Suwanee, GA',
    logo: 'https://readdy.ai/api/search-image?query=barre%20fitness%20studio%20logo%20with%20ballet%20barre%20silhouette%20elegant%20rose%20and%20gold%20tones%20feminine%20fitness%20branding%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo11&orientation=squarish',
    description: 'Barre classes you can bring your baby to! Low-impact, high-intensity workout focusing on core strength and posture. Perfect for postpartum moms looking to rebuild strength in a welcoming space.',
    averageRating: 4.7,
    reviewCount: 22,
    reviews: [
      { reviewerName: 'Olivia M.', rating: 5, comment: 'Perfect for new moms! I can bring my baby and still get a great workout.', date: '2024-06-16' },
      { reviewerName: 'Hannah P.', rating: 4, comment: 'Great postpartum workout. My core is getting stronger and baby loves watching!', date: '2024-06-04' }
    ],
    memberDiscount: '20% off monthly membership',
    tags: ['Postpartum', 'Barre', 'Baby-Friendly']
  },
  {
    id: 'ma-12',
    name: 'Sweet Treats Dessert Bar',
    category: 'Party Vendors',
    location: 'Sugar Hill, GA',
    isFeaturedPartner: true,
    logo: 'https://readdy.ai/api/search-image?query=dessert%20bar%20bakery%20logo%20with%20cupcake%20and%20sweets%20design%20pastel%20pink%20and%20gold%20colors%20sweet%20bakery%20branding%20cute%20minimalist%20on%20white%20background&width=200&height=200&seq=malogo12&orientation=squarish',
    description: 'Custom dessert tables and candy buffets for parties and events. Cupcakes, cookies, cake pops, and more. Beautiful themed displays that become the centerpiece of any celebration.',
    averageRating: 4.8,
    reviewCount: 32,
    reviews: [
      { reviewerName: 'Peyton K.', rating: 5, comment: 'The dessert table was the centerpiece of the party! Delicious and absolutely beautiful!', date: '2024-06-12' },
      { reviewerName: 'Addison R.', rating: 5, comment: 'Everything tasted as good as it looked! Highly recommend for any party.', date: '2024-05-30' }
    ],
    memberDiscount: 'Free custom cookies with dessert table order',
    tags: ['Dessert Tables', 'Custom Cakes', 'Candy Buffets']
  }
];

export const categoryFilters = [
  'All',
  'Photographers',
  'Mom Businesses',
  'Fitness',
  'Party Vendors',
  'Hair & Beauty',
  'Kids Activities',
  'Tutors',
  'Doctors'
];
